import React from 'react';

// styled core
import styled, { css } from 'styled-components/macro';

// locales
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/i18n';

import { ReactComponent as Bookmark } from '../../assets/icons/bookmark.svg';
import { ReactComponent as BookmarkHover } from '../../assets/icons/bookmark-hover.svg';
import { ReactComponent as BookmarkFilled } from '../../assets/icons/bookmark-filled-webinar.svg';

interface IProps {
  active: boolean | undefined;
  dontShowTitle?: boolean | undefined;
  click: () => void;
  colorType: SaveToggleStyles;
}

interface IStyledProps {
  active: boolean | undefined;
  dontShowTitle?: boolean | undefined;
  colorType: SaveToggleStyles;
}

export enum SaveToggleStyles {
  Light = 'light',
  Default = 'default',
}

const Wrapper = styled.button<IStyledProps>`
  position: relative;
  display: flex;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  white-space: nowrap;
  border: none;
  background: transparent;
  outline: none;
  cursor: pointer;
  z-index: 2;
  padding: 0;
  color: ${props =>
    props.active
      ? props.theme.colors.primary
      : props.colorType === SaveToggleStyles.Light
      ? 'white'
      : props.theme.colors.black};

  svg {
    .border {
      fill: ${props => props.colorType === SaveToggleStyles.Light && 'white'};
    }

    .border,
    .inner {
      fill: ${props => props.active && props.theme.colors.primary};
    }
  }

  &:hover {
    color: ${props => props.theme.colors.primary};

    svg {
      .border {
        fill: ${props => props.theme.colors.primary};
      }
    }
  }

  .bookmark {
    .hover {
      display: none;
      position: relative;

      ${props =>
        !props.dontShowTitle &&
        css`
          &:before {
            content: 'До обраного';
            background: #000;
            color: #fff;
            padding: 6px 6px;
            font-size: 12px;
            font-weight: 400;
            line-height: 14px;
            border-radius: 4px;
            position: absolute;
            transform: translateX(-43%);
            top: -33px;
          }

          &:after {
            content: '';
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 6px solid #000;
            position: absolute;
            top: -8px;
            left: 6px;
          }
        `}
    }

    &:hover {
      .standard {
        display: none;
      }

      .hover {
        display: block;
      }
    }
  }
`;

export const SaveButtonWebinar = ({
  active,
  dontShowTitle,
  click,
  colorType,
}: IProps) => {
  // locales hook
  const { t } = useTranslation();

  return (
    <Wrapper
      active={active}
      dontShowTitle={dontShowTitle}
      colorType={colorType}
      onClick={click}
    >
      <div className="bookmark">
        {active ? (
          <BookmarkFilled />
        ) : (
          <>
            <div className="standard">
              <Bookmark />
            </div>
            <div className="hover">
              <BookmarkHover />
            </div>
          </>
        )}
      </div>
    </Wrapper>
  );
};

export default SaveButtonWebinar;
